import { render, staticRenderFns } from "./designation.vue?vue&type=template&id=0d8bbfa6&"
import script from "./designation.vue?vue&type=script&lang=js&"
export * from "./designation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports